import {
  HTTP_GETAPPROVEHISTORY_FETCHING,
  HTTP_GETAPPROVEHISTORY_SUCCESS,
  HTTP_GETAPPROVEHISTORY_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";
export const setStateApproveHistoryToFetching = () => ({
  type: HTTP_GETAPPROVEHISTORY_FETCHING,
});

export const setStateApproveHistoryToSuccess = (payload) => ({
  type: HTTP_GETAPPROVEHISTORY_SUCCESS,
  payload,
});

export const setStateApproveHistoryToFailed = (payload) => ({
  type: HTTP_GETAPPROVEHISTORY_FAILED,
});

export const clearApproveHistory = () => {
  return async (dispatch) => {
    dispatch(
      setStateApproveHistoryToSuccess({
        data: [],
      })
    );
  };
};

export const getApproveByIdHistory = (
  year,
  memid,
  secureid,
  countryid,
  companyid
) => {
  return async (dispatch) => {
    dispatch(setStateApproveHistoryToFetching());

    try {
      const result = await httpClient.get(
        `${server.GETAPPROVEHISTORY_URL}/${year}/${memid}/${secureid}/${countryid}/${companyid}`
      );
      dispatch(
        setStateApproveHistoryToSuccess({
          data: result.data,
        })
      );
      return Promise.resolve(result.data);
    } catch (error) {
      // console.log("aaaaa");
      dispatch(setStateApproveHistoryToFailed());

      return Promise.reject(error.message);
    }
  };
};
